export const sortCalendarItem = (array, type) => {
  switch (type) {
    case "lessons":
      return array.sort((a, b) => {
        if (a.lesson && b.lesson) {
          return parseInt(a.lesson.starting_page, 10) - parseInt(b.lesson.starting_page, 10);
        }
        if (parseInt(a.starting_page, 10) === parseInt(b.starting_page, 10)) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
        }
        return parseInt(a.starting_page, 10) - parseInt(b.starting_page, 10);
      });
    case "worksheets":
      return array.sort((a, b) => {
        if (a.worksheet?.title < b.worksheet?.title) {
          return -1;
        }
        if (a.worksheet?.title > b.worksheet?.title) {
          return 1;
        }
        return 0;
      });
    case "tests":
      return array.sort((a, b) => {
        if (a.test?.name < b.test?.name) {
          return -1;
        }
        if (a.test?.name > b.test?.name) {
          return 1;
        }
        return 0;
      });
    default:
      return array?.sort((a, b) => (a.date > b.date ? 1 : -1));
  }
};

const hierarchySortFunc = (a, b) => {
  if (a.label > b.label) return 1;
  return -1;
};

export const hierarchySort = (hashArr, key, result, tier) => {
  if (hashArr[key] == undefined) return;
  const arr = hashArr[key].sort(hierarchySortFunc);
  for (let i = 0; i < arr.length; i++) {
    // The code below adds white space or indentions for children nodes
    arr[i].label = `${"­­­­­\u00AD \u00AD \u00AD \u00AD".repeat(tier)} ${arr[i].label} (${
      arr[i].worksheetCount
    })`;
    result.push(arr[i]);
    hierarchySort(hashArr, arr[i].value, result, tier + 1);
  }
  return result;
};

export const getFormattedCategories = (categories) => {
  const arr = categories?.map((category) => ({
    label: category.name.trim(),
    value: category.id,
    parentId: category.parent_id,
    worksheetCount: category.worksheet_count
  }));

  const hashArr = {};

  for (let i = 0; i < arr.length; i++) {
    if (hashArr[arr[i].parentId] == undefined) hashArr[arr[i].parentId] = [];
    hashArr[arr[i].parentId].push(arr[i]);
  }

  return hierarchySort(hashArr, "null", [], 0);
};

export const sortByProperty = (data: any[], property: string, type: SortingType = "asc") =>
  data.sort((a, b) => {
    const valueA = a[property];
    const valueB = b[property];
    const checkedA = isNaN(valueA) ? valueA : parseInt(valueA, 10);
    const checkedB = isNaN(valueB) ? valueB : parseInt(valueB, 10);
    if (type === "asc" && checkedA > checkedB) return 1;
    if (type === "desc" && checkedA < checkedB) return 1;
    return -1;
  });

interface INestedSearchOptions {
  /** sort by specific value or none */
  lookForValue?: string;
  /** sort by substring elements first */
  sortSublistFirst?: string;
  index?: number | string;
  subProperty?: string;
}

export const sortByNestedProperty = (
  data: any[],
  mainProperty: string,
  type: SortingType = "asc",
  options?: INestedSearchOptions
) => {
  return data.sort((a, b) => {
    let valueA;
    let valueB;

    if (options?.index !== undefined && options?.subProperty) {
      valueA = a[mainProperty][options?.index][options.subProperty];
      valueB = b[mainProperty][options?.index][options.subProperty];
    } else if (!options?.subProperty && options?.index) {
      valueA = a[mainProperty]?.[options?.index];
      valueB = b[mainProperty]?.[options?.index];
    } else {
      valueA = a[mainProperty];
      valueB = b[mainProperty];
    }

    let checkedA = !isNumeric(valueA) ? valueA : parseInt(valueA, 10);
    let checkedB = !isNumeric(valueB) ? valueB : parseInt(valueB, 10);

    if (options?.lookForValue) {
      const boolA = checkedA === options?.lookForValue ? 1 : -1;
      const boolB = checkedB === options?.lookForValue ? 1 : -1;
      if (type === "asc" && boolA > boolB) return 1;
      if (type === "desc" && boolA < boolB) return 1;
      return -1;
    }

    if (type === "asc" && checkedA > checkedB) return 1;
    if (type === "desc") {
      if (checkedA === checkedB) {
        return 0;
      }
      // nulls sort after anything else
      else if (checkedA === null) {
        return 1;
      } else if (checkedB === null) {
        return -1;
      }
      if (checkedA < checkedB) return 1;
    }
    return -1;
  });
};

export const isNumeric = (val) => {
  return /^-?\d+$/.test(val);
};
